import React from "react";

const Investors = () => {
  return (
    <section id="investors" className="max-width">
      <div className="container d-flex flex-column align-items-center">
        <h5 className="mb-4">Investors</h5>
        <img src="./images/investor.png" alt="Investors" />
      </div>
      <div className="container text-center mt-5">
        <h5 className="mb-4">Strategic Partners</h5>
        <img src="./images/strategic_partners.png" alt="Investors" />
      </div>
    </section>
  );
};

export default Investors;
